export default "__VITE_ASSET__Do56yaRz__"